module.exports = __webpack_public_path__ + "img/bg-scene-1.03cf1a84.png";